import { fromJS } from "immutable";
import { call, put, select } from "redux-saga/effects";

import type { RootState } from "store/redux";
import * as StatusActions from "store/redux/status";
import type {
  IEditP8SConfig,
  IGetConfig,
  IGetZone,
  IP8SConfigPayload,
  IResetConfig,
} from "store/redux/zone";
import * as ZoneActions from "store/redux/zone";
import { zonesApi } from "api";

import type { IAction } from "./types";

const getZoneDataFromStore = (state: RootState) => state.zone;

// export function* getZones() {
//   // @ts-ignore
//   const data = yield call(zonesApi.getAllZone);
//   yield put(ZoneActions.setData({ key: "zoneList", value: fromJS(data) }));
// }

export function* getZone(action: IAction<IGetZone>) {
  let { zoneId } = action.payload;

  if (!zoneId) {
    // zoneId가 없을 경우
    // @ts-ignore
    const clusterList = yield call(zonesApi.getAllZone);
    if (clusterList.length <= 0) {
      yield put(ZoneActions.setData({ key: "error", value: true }));
      return;
    }
    zoneId = clusterList[0].id;
  }

  try {
    // @ts-ignore
    const detailZone = yield call(zonesApi.getZone, zoneId);

    if (!detailZone) {
      // throw error if there's no zone info
      yield put(ZoneActions.setData({ key: "error", value: true }));
    } else {
      const iDetailZone = fromJS(detailZone);
      yield put(ZoneActions.setData({ key: "detailZone", value: iDetailZone }));
    }
  } catch (error) {
    if (error.response.status === 404) {
      yield put(ZoneActions.setData({ key: "error", value: true }));
    } else {
      throw error;
    }
  }
}

function* getConifg(
  param: IGetConfig,
  api: any,
  statusKey: any,
  configKey: any
) {
  try {
    const { zoneId, statusOnly, yamlName } = param;
    if (zoneId !== 0 && !zoneId) return;
    // @ts-ignore
    const data = yield call(api, zoneId, statusOnly, yamlName);
    // @ts-ignore
    const zoneStore = yield select(getZoneDataFromStore);
    const configData = zoneStore.get(configKey);
    const failedKeyList = ["TEST_FAILED", "TEST_ERROR"];

    // TODO: Test용 status
    /*if (testStart) {
      ++test;
      data.configurationStatus = "OK";
      if (test === 1) {
        data.contents = "Test Contents";
      }
      if (test > 1) {
        data.configurationStatus = "TESTING";
      }

      if (test > 3) {
        console.log("testFailed");
        data.configurationStatus = "TEST_FAILED";
        data.testLog =
          "Checking /tmp/Nex-prom_config_test.yArfsHCc.yaml↵↵  FAILED: parsing YAML file /tmp/Nex-prom_config_test.yArfsHCc.yaml: global scrape timeout greater than scrape interval↵command terminated with exit code 1";
      }

      if (test > 6) {
        data.configurationStatus = "UPDATING";
      }
      if (test > 8) {
        data.configurationStatus = "APPLY_ERROR";
      }
    }*/

    const testFailed = failedKeyList.includes(data.configurationStatus);

    yield put(
      ZoneActions.setData({ key: statusKey, value: data.configurationStatus })
    );
    if (!testFailed && statusOnly) {
      // Config status 만 요청했다면 contents는 update 하지 않는다.
      return;
    } else if (testFailed && configData) {
      // Test 실패했다면 Test Log를 저장한다.
      yield put(
        ZoneActions.setData({
          key: configKey,
          value: configData.set("testLog", data.testLog),
        })
      );
    } else {
      data.contents = data.contents || "";
      yield put(ZoneActions.setData({ key: configKey, value: fromJS(data) }));
    }
  } catch (error) {
    yield put(
      StatusActions.openMessage({
        type: "error",
        msg: "Server Error",
      })
    );
    yield put(ZoneActions.setData({ key: statusKey, value: "ERROR" }));
    throw error;
  }
}

export function* getAlertConfig(action: IAction<IGetConfig>) {
  yield call(
    getConifg,
    action.payload,
    zonesApi.getAlertConfig,
    "alertConfigStatus",
    "alertConfig"
  );
}

export function* getP8SConfig(action: IAction<IGetConfig>) {
  yield call(
    getConifg,
    action.payload,
    zonesApi.getP8SConfig,
    "p8sConfigStatus",
    "prometheusConfig"
  );
}

export function* getP8SServices(action: IAction<number>) {
  // @ts-ignore
  const res = yield call(zonesApi.getP8SServices, action.payload);
  const value = fromJS(res?.p8sServices ?? []);
  yield put(ZoneActions.setData({ key: "p8sServices", value }));
}

export function* editP8SConfig(action: IAction<IEditP8SConfig>) {
  try {
    const { zoneId, contents, yamlName } = action.payload;
    yield call(zonesApi.putP8SConfig, { zoneId, contents, yamlName });
    yield put(ZoneActions.getP8SConfig({ zoneId, yamlName }));
  } catch (error) {
    yield put(ZoneActions.setData({ key: "p8sConfigStatus", value: "ERROR" }));
    throw error;
  }
}

export function* editAlertConfig(action: IAction<IEditP8SConfig>) {
  try {
    const { zoneId, contents, yamlName } = action.payload;
    yield call(zonesApi.putAlertConfig, { zoneId, contents, yamlName });
    yield put(ZoneActions.getAlertConfig({ zoneId, yamlName }));
  } catch (error) {
    yield put(
      ZoneActions.setData({ key: "alertConfigStatus", value: "ERROR" })
    );
    throw error;
  }
}

export function* getClusterHealth(action: IAction<number>) {
  const { payload: zoneId } = action;
  // @ts-ignore
  const data = yield call(zonesApi.getClusterHealth, zoneId);

  // // Test용 data
  // const data1 = {
  //   clusterAge: "0.66",
  //   clusterStatus: "Not Ready",
  //   clusterNodes: 1,
  //   clusterNaNodes: 0,
  //   clusterNamespaces: 6,
  //   clusterPodUsage: "19.090909090909093",
  //   clusterCpuUsage: "27.924514231139035",
  //   clusterMemoryUsage: "69.93340407224146",
  //   clusterDiskUsage: "50.29740150509614",
  //   clusterPods: 21,
  //   restartedPods: 1,
  //   failedPods: 0,
  //   pendingPods: 0,
  //   pvcs: 4,
  //   p8sStatus: "Up",
  //   alertManagerStatus: "Up",
  //   apiServerStatus: "Up",
  //   apiServerResponseStatus:
  //     '[{"1606436701548":[{"metric":{"code":"0"},"value":[1.606436701548E9,"0.521439506759942"]},{"metric":{"code":"200"},"value":[1.606436701548E9,"5.4313139024115555"]},{"metric":{"code":"201"},"value":[1.606436701548E9,"0.0041715160540795335"]},{"metric":{"code":"404"},"value":[1.606436701548E9,"0"]},{"metric":{"code":"409"},"value":[1.606436701548E9,"0"]},{"metric":{"code":"500"},"value":[1.606436701548E9,"0"]}]},{"1606436761766":[{"metric":{"code":"0"},"value":[1.606436761766E9,"0.49641041043546463"]},{"metric":{"code":"200"},"value":[1.606436761766E9,"5.435485418465634"]},{"metric":{"code":"201"},"value":[1.606436761766E9,"0.0041715160540795335"]},{"metric":{"code":"404"},"value":[1.606436761766E9,"0"]},{"metric":{"code":"409"},"value":[1.606436761766E9,"0"]},{"metric":{"code":"500"},"value":[1.606436761766E9,"0"]}]},{"1606436821599":[{"metric":{"code":"200"},"value":[1.606436821599E9,"5.418799354249318"]},{"metric":{"code":"201"},"value":[1.606436821599E9,"0.0041715160540795335"]},{"metric":{"code":"404"},"value":[1.606436821599E9,"0"]},{"metric":{"code":"409"},"value":[1.606436821599E9,"0"]},{"metric":{"code":"500"},"value":[1.606436821599E9,"0"]},{"metric":{"code":"0"},"value":[1.606436821599E9,"0.5047534425436238"]}]},{"1606436881537":[{"metric":{"code":"200"},"value":[1.606436881537E9,"5.431313902411555"]},{"metric":{"code":"201"},"value":[1.606436881537E9,"0.0041715160540795335"]},{"metric":{"code":"404"},"value":[1.606436881537E9,"0"]},{"metric":{"code":"409"},"value":[1.606436881537E9,"0"]},{"metric":{"code":"500"},"value":[1.606436881537E9,"0"]},{"metric":{"code":"0"},"value":[1.606436881537E9,"0.49223889438138524"]}]},{"1606436941639":[{"metric":{"code":"200"},"value":[1.606436941639E9,"5.4730290629523495"]},{"metric":{"code":"201"},"value":[1.606436941639E9,"0"]},{"metric":{"code":"404"},"value":[1.606436941639E9,"0"]},{"metric":{"code":"409"},"value":[1.606436941639E9,"0"]},{"metric":{"code":"500"},"value":[1.606436941639E9,"0"]},{"metric":{"code":"0"},"value":[1.606436941639E9,"0.584012247571135"]}]}]',
  // };

  yield put(ZoneActions.setData({ key: "clusterHealth", value: fromJS(data) }));
}

// export function* getTasks(action: IAction<IGetZone>) {
//   const { zoneId } = action.payload;
//   // @ts-ignore
//   const data = yield call(tasksApi.getTasks, +zoneId);
//   yield put(
//     ZoneActions.setData({ key: "taskData", value: fromJS(data || []) })
//   );
// }

export function* applyP8SConfig(action: IAction<IP8SConfigPayload>) {
  try {
    const {
      payload: { zoneId, yamlName },
    } = action;

    yield call(zonesApi.postP8SConfig, { zoneId, yamlName });
    yield put(ZoneActions.getP8SConfig({ zoneId, yamlName, statusOnly: true }));
  } catch (error) {
    yield put(ZoneActions.setData({ key: "p8sConfigStatus", value: "ERROR" }));
    throw error;
  }
}

export function* applyAlertConfig(action: IAction<IP8SConfigPayload>) {
  try {
    const {
      payload: { zoneId, yamlName },
    } = action;
    yield call(zonesApi.postAlertConfig, { zoneId, yamlName });
    yield put(
      ZoneActions.getAlertConfig({ zoneId, statusOnly: true, yamlName })
    );
  } catch (error) {
    yield put(
      ZoneActions.setData({ key: "alertConfigStatus", value: "ERROR" })
    );
    throw error;
  }
}

export function* resetConfig(action: IAction<IResetConfig>) {
  const { type, zoneId, yamlName } = action.payload;
  const isP8S = type === "prometheus";
  const api = isP8S ? zonesApi.resetP8SConfig : zonesApi.resetAlertConfig;
  // @ts-ignore
  const data = yield call(api, { zoneId, yamlName });
  const configKey = isP8S ? "prometheusConfig" : "alertConfig";

  yield put(ZoneActions.setData({ key: configKey, value: fromJS(data) }));
  yield put(
    StatusActions.openMessage({
      type: "success",
      msg: "It has been successfully initialized.",
    })
  );
}
